import { JsBridge } from '@loca/mfe-vue3'
import Analytics from '@/core/Analytics'

export default function afterEach(to: any, from: any) {
  // try {
  // 兼容 vue-router4 的各类 history.state 异常
  // if (!window.history.state) (window.history.state as any) = {}
  // if (!window.history.state.back) window.history.state.back = from.path
  // if (!window.history.state.current) window.history.state.current = to.path
  // } catch {}

  if (!to.meta.isMicroApp) {
    // 仅当页面为微前端非子应用时，主动触发 pv 上报
    // 为保证 title 的准确性，各子应用的 pv 由其自身内部上报
    Analytics.trackPageView()

    // 设置自定义分享
    try {
      const metaShareData = to.meta?.share
      if (metaShareData) {
        const data = typeof metaShareData === 'object' ? metaShareData : {}
        JsBridge.setShareData(data)
      } else {
        JsBridge.clearShareData()
      }
    } catch (error: any) {
      console.error(error)
    }
  }
}
